import { supabaseClient } from "../../services/supabase";

import type {
  EditarProdutoInput,
  EstoqueProduto,
  MovimentoEstoque,
  NovoProdutoInput,
} from "./types";

type ProdutoResult = {
  success: boolean;

  produto: EstoqueProduto;
};

type MovimentoResult = {
  success: boolean;

  produto: EstoqueProduto;

  quantidade_antes: number;

  quantidade_depois: number;

  diferenca?: number;
};

export async function loadEstoque(): Promise<
  EstoqueProduto[]
> {
  const { data, error } =
    await supabaseClient
      .from("estoque")
      .select("*")
      .order("nome");

  if (error) {
    throw error;
  }

  return (data ?? []) as EstoqueProduto[];
}

export async function loadMovimentosEstoque(
  estoqueId: string,
): Promise<MovimentoEstoque[]> {
  const { data, error } =
    await supabaseClient
      .from("movimentos_estoque")
      .select("*")
      .eq("estoque_id", estoqueId)
      .order("created_at", {
        ascending: false,
      })
      .limit(50);

  if (error) {
    throw error;
  }

  return (data ?? []) as MovimentoEstoque[];
}

export async function criarProduto(
  input: NovoProdutoInput,
): Promise<EstoqueProduto> {
  const { data, error } =
    await supabaseClient.rpc(
      "estoque_criar_produto",
      {
        p_nome:
          input.nome,

        p_unidade:
          input.unidade,

        p_quantidade_inicial:
          input.quantidadeInicial,

        p_estoque_minimo:
          input.estoqueMinimo,

        p_valor:
          input.valor,

        p_created_by:
          input.createdBy ??
          null,
      },
    );

  if (error) {
    throw error;
  }

  const result =
    data as ProdutoResult;

  return result.produto;
}

export async function editarProduto(
  input: EditarProdutoInput,
): Promise<EstoqueProduto> {
  const { data, error } =
    await supabaseClient.rpc(
      "estoque_editar_produto",
      {
        p_estoque_id:
          input.id,

        p_nome:
          input.nome,

        p_unidade:
          input.unidade,

        p_estoque_minimo:
          input.estoqueMinimo,

        p_valor:
          input.valor,
      },
    );

  if (error) {
    throw error;
  }

  const result =
    data as ProdutoResult;

  return result.produto;
}

export async function registrarEntrada(
  estoqueId: string,
  quantidade: number,
  motivo: string,
  createdBy?: string | null,
): Promise<MovimentoResult> {
  const { data, error } =
    await supabaseClient.rpc(
      "estoque_entrada",
      {
        p_estoque_id:
          estoqueId,

        p_quantidade:
          quantidade,

        p_motivo:
          motivo || null,

        p_created_by:
          createdBy ?? null,
      },
    );

  if (error) {
    throw error;
  }

  return data as MovimentoResult;
}

export async function ajustarEstoque(
  estoqueId: string,
  novaQuantidade: number,
  motivo: string,
  createdBy?: string | null,
): Promise<MovimentoResult> {
  const { data, error } =
    await supabaseClient.rpc(
      "estoque_ajustar",
      {
        p_estoque_id:
          estoqueId,

        p_nova_quantidade:
          novaQuantidade,

        p_motivo:
          motivo,

        p_created_by:
          createdBy ?? null,
      },
    );

  if (error) {
    throw error;
  }

  return data as MovimentoResult;
}

export async function alterarStatusProduto(
  estoqueId: string,
  ativo: boolean,
): Promise<EstoqueProduto> {
  const { data, error } =
    await supabaseClient.rpc(
      "estoque_alterar_status_produto",
      {
        p_estoque_id: estoqueId,
        p_ativo: ativo,
      },
    );

  if (error) {
    throw error;
  }

  const result = data as ProdutoResult;
  return result.produto;
}
